import { render } from "./Mystic.svg?vue&type=template&id=6d1f71d0"
const script = {}
script.render = render

export default script